'use strict';

const $ = window.jQuery;

function stickyHeader () {
    const scrollTop = $(window).scrollTop();

    if ( scrollTop > 0 ) {
        $('body').addClass('header-sticked');
        $('#header').addClass('is-sticky');
    } else {
        $('body').removeClass('header-sticked');
        $('#header').removeClass('is-sticky');
    }
}

module.exports = function () {
    // Menus
    $('.nav-main-l1__link').on('click', function (e) {
        const navItem = $(this).parent();

        $('.header__useful, .account-menu, .lang-switcher, .nav-main-l1__item').not(navItem).removeClass('is-active');

        if (navItem.hasClass('menu-item-has-children')) {
            e.preventDefault();
            e.stopPropagation();
            navItem.toggleClass('is-active');
        }
    });

    // Language switcher
    $('.lang-switcher__deployer').on('click', function (e) {
        e.stopPropagation();

        $('.lang-switcher').toggleClass('is-active');
        $('.header__useful, .account-menu, .nav-main-l1__item').removeClass('is-active');
    });

    // Useful links
    $('.header__useful__link--account').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        $(this).parent().toggleClass('is-active');
        $(this).next().toggleClass('is-active');
        $('.lang-switcher, .nav-main-l1__item').removeClass('is-active');
    });

    // Close all
    $('body').on('click', function () {
        $('.header__useful, .nav-main-l1__item, .lang-switcher, .account-menu').removeClass('is-active');
    });

    // Sticky
    stickyHeader ()
    $(window).scroll(function () {
        stickyHeader ()
    });
};
